import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-admin-dash',
  templateUrl: './admin-dash.component.html',
  styleUrls: ['./admin-dash.component.css']
})
export class AdminDashComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document: Document, private renderer: Renderer2,private router: Router, private _rest: RestapiService) { }

  ngOnInit(): void {
  	this.document.location.href = this._rest.ADMIN_DASH+'/auth/loginWithAnalyst/'+localStorage.getItem('userId');
  }

}
